// #region Imports
import {
    createContext,
    useContext,
    useRef,
} from "react"

import { createPortal } from "react-dom"
// #endregion

const PortalContext = createContext(null)
export const PortalProvider = ({ children }) => {
    const root = useRef(null)
    return (
        <PortalContext.Provider
            value={{ root }}
        >
            {children}

            <div 
                className="contents" 
                ref={root}
            />
        </PortalContext.Provider>
    )
}

export const Portal = ({
    children,
}) => {
    const context = useContext(
        PortalContext
    )

    if (!context?.root.current)
        return null

    return createPortal(
        children,
        context.root.current
    )
}